import { useEffect, useRef, useState } from "react";
import FakturPrint, { bersihkanWadahCetak, isStruk, siapkanWadahCetak } from "./FakturPrint";
import StrukPrint from "./StrukPrint";
import InvoiceDigital from "./InvoiceDigital";

export default function InvoicePreview({ data, publik = false }) {
  const [paper, setPaper] = useState(false);
  const container = useRef(null);
  useEffect(() => {
    let prepared = false;
    const before = () => {
      if (!document.getElementById("print-root")) prepared = siapkanWadahCetak(container.current?.querySelector(".print-area"));
    };
    const after = () => { if (prepared) bersihkanWadahCetak(); prepared = false; };
    // Browser menu / Ctrl+P must isolate the paper document just like our button.
    window.addEventListener("beforeprint", before);
    window.addEventListener("afterprint", after);
    return () => { window.removeEventListener("beforeprint", before); window.removeEventListener("afterprint", after); after(); };
  }, []);
  const Paper = isStruk(data.template) ? StrukPrint : FakturPrint;
  return <div ref={container}>
    {!publik && <div className="invoice-view-switch no-print" aria-label="Tampilan faktur">
      <button type="button" aria-pressed={!paper} onClick={() => setPaper(false)}>Faktur digital</button>
      <button type="button" aria-pressed={paper} onClick={() => setPaper(true)}>Format cetak</button>
    </div>}
    {!paper && <InvoiceDigital payload={data} />}
    <div className={paper ? "invoice-print-preview" : "invoice-paper-hidden"}>
      <Paper data={data} publik={publik} tampilkanTombolCetak={paper} />
    </div>
  </div>;
}
